import React from 'react';

// 전원 카드 (플러그)
const PowerIcon = ({ width = 24, height = 24, color = '#0F7F85' }) => (
  <svg width={width} height={height} viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 2V7M15 2V7M5 7H17V10C17 13.3137 14.3137 16 11 16C7.68629 16 5 13.3137 5 10V7Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M11 16V21" stroke={color} strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default PowerIcon;
